import { ReactElement, ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ModalPanel, Overlay } from './styles';

interface ModalShellProps {
  width: number;
  onClose: () => void;
  children: ReactNode;
}

/** Janela do design: faixa na cor primária, centralizada no desktop e como folha inferior no celular. */
export function ModalShell({ width, onClose, children }: Readonly<ModalShellProps>): ReactElement {
  useEffect(() => {
    function onKeyDown(event: KeyboardEvent): void {
      if (event.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  // O portal não isola os eventos do React: sem barrar aqui, o submit do formulário do modal subiria
  // até o formulário da tela, que salvaria a configuração com os valores de antes da edição.
  return createPortal(
    <Overlay
      onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}
      onSubmit={(event) => event.stopPropagation()}
    >
      <ModalPanel open $width={width} aria-modal>
        {children}
      </ModalPanel>
    </Overlay>,
    document.body,
  );
}
